export interface LaundryRating {
  id: string;
  clientName: string;
  clientInitial: string;
  stars: number;
  comment: string;
  date: string;
  orderNo: string;
}

export interface DriverRating {
  driverId: string;
  driverName: string;
  driverPhoto: string;
  averageStars: number;
  totalRatings: number;
  reviews: {
    id: string;
    clientName: string;
    clientInitial: string;
    stars: number;
    comment: string;
    date: string;
    orderNo: string;
    taskType: string;
  }[];
}

export const laundryRatings: LaundryRating[] = [
  {
    id: 'R-001',
    clientName: 'نورة العتيبي',
    clientInitial: 'ن',
    stars: 5,
    comment: 'خدمة ممتازة! الملابس رجعت نظيفة ومكوية بشكل احترافي، والتوصيل كان في الوقت المحدد تماماً.',
    date: '2026-09-16',
    orderNo: '#98756',
  },
  {
    id: 'R-002',
    clientName: 'محمد السبيعي',
    clientInitial: 'م',
    stars: 4,
    comment: 'خدمة جيدة جداً، الغسيل نظيف والكوي ممتاز. سأتعامل معهم مرة أخرى.',
    date: '2026-09-15',
    orderNo: '#98744',
  },
  {
    id: 'R-003',
    clientName: 'سارة الحربي',
    clientInitial: 'س',
    stars: 5,
    comment: 'من أفضل المغاسل في الحي. سريعة في التنفيذ ودقيقة في العناية بالملابس.',
    date: '2026-09-15',
    orderNo: '#98741',
  },
  {
    id: 'R-004',
    clientName: 'عبدالله الشمري',
    clientInitial: 'ع',
    stars: 3,
    comment: 'الخدمة معقولة لكن التأخير في التسليم كان ملحوظاً مقارنة بالوقت المحدد.',
    date: '2026-09-14',
    orderNo: '#98729',
  },
  {
    id: 'R-005',
    clientName: 'ريم القحطاني',
    clientInitial: 'ر',
    stars: 5,
    comment: 'أنصح بها بشدة. الثوب رجع أفضل من الجديد، والكوي محكم جداً.',
    date: '2026-09-13',
    orderNo: '#98715',
  },
  {
    id: 'R-006',
    clientName: 'فيصل الزهراني',
    clientInitial: 'ف',
    stars: 4,
    comment: 'خدمة ممتازة والسعر معقول. فقط أتمنى أن يكون هناك خيار للتتبع المباشر.',
    date: '2026-09-12',
    orderNo: '#98702',
  },
  {
    id: 'R-007',
    clientName: 'منى العسيري',
    clientInitial: 'م',
    stars: 5,
    comment: 'مرتاحة جداً من الخدمة. الفستان رجع مثل ما اشتريته تماماً.',
    date: '2026-09-11',
    orderNo: '#98688',
  },
  {
    id: 'R-008',
    clientName: 'خالد الغامدي',
    clientInitial: 'خ',
    stars: 2,
    comment: 'كان فيه بعض البقع في أحد الثياب بعد الغسيل، لكن أعادوا غسله مجاناً.',
    date: '2026-09-10',
    orderNo: '#98671',
  },
  {
    id: 'R-009',
    clientName: 'لطيفة الدوسري',
    clientInitial: 'ل',
    stars: 5,
    comment: 'دايماً أتعامل معهم وما قصّروا أبداً. الاحترافية عالية والاهتمام بالتفاصيل واضح.',
    date: '2026-09-09',
    orderNo: '#98659',
  },
  {
    id: 'R-010',
    clientName: 'أحمد المطيري',
    clientInitial: 'أ',
    stars: 4,
    comment: 'الكوي ممتاز والغسيل نظيف. التوصيل في الوقت المحدد تقريباً.',
    date: '2026-09-08',
    orderNo: '#98644',
  },
];

export const driverRatings: DriverRating[] = [
  {
    driverId: 'DRV-101',
    driverName: 'فهد العتيبي',
    driverPhoto:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20friendly%20Arab%20man%20in%20a%20clean%20light%20blue%20uniform%20shirt%2C%20neutral%20bright%20studio%20background%2C%20soft%20even%20lighting%2C%20corporate%20identity%20photo%2C%20sharp%20and%20clear&width=200&height=200&seq=driver-photo-101&orientation=squarish',
    averageStars: 4.8,
    totalRatings: 47,
    reviews: [
      {
        id: 'DR-101-1',
        clientName: 'نورة العتيبي',
        clientInitial: 'ن',
        stars: 5,
        comment: 'مندوب محترم وسريع في التسليم.',
        date: '2026-09-16',
        orderNo: '#98756',
        taskType: 'تسليم',
      },
      {
        id: 'DR-101-2',
        clientName: 'سارة الحربي',
        clientInitial: 'س',
        stars: 5,
        comment: 'جاء في الوقت المحدد ومعه كل الطلبات.',
        date: '2026-09-14',
        orderNo: '#98730',
        taskType: 'استلام',
      },
      {
        id: 'DR-101-3',
        clientName: 'محمد السبيعي',
        clientInitial: 'م',
        stars: 4,
        comment: 'خدمة جيدة.',
        date: '2026-09-12',
        orderNo: '#98705',
        taskType: 'تسليم',
      },
    ],
  },
  {
    driverId: 'DRV-102',
    driverName: 'سلطان الحربي',
    driverPhoto:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20Arab%20man%20with%20a%20short%20beard%20wearing%20a%20navy%20polo%20shirt%2C%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20identity%20photo%2C%20high%20detail&width=200&height=200&seq=driver-photo-102&orientation=squarish',
    averageStars: 4.6,
    totalRatings: 38,
    reviews: [
      {
        id: 'DR-102-1',
        clientName: 'ريم القحطاني',
        clientInitial: 'ر',
        stars: 5,
        comment: 'سريع ومنظم جداً.',
        date: '2026-09-15',
        orderNo: '#98748',
        taskType: 'تسليم',
      },
      {
        id: 'DR-102-2',
        clientName: 'فيصل الزهراني',
        clientInitial: 'ف',
        stars: 4,
        comment: 'جيد في التعامل.',
        date: '2026-09-13',
        orderNo: '#98718',
        taskType: 'استلام',
      },
    ],
  },
  {
    driverId: 'DRV-103',
    driverName: 'خالد الزهراني',
    driverPhoto:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Arab%20man%20in%20a%20white%20shirt%2C%20plain%20soft%20beige%20studio%20background%2C%20warm%20soft%20lighting%2C%20corporate%20identity%20photo%2C%20crisp%20detail&width=200&height=200&seq=driver-photo-103&orientation=squarish',
    averageStars: 4.9,
    totalRatings: 29,
    reviews: [
      {
        id: 'DR-103-1',
        clientName: 'منى العسيري',
        clientInitial: 'م',
        stars: 5,
        comment: 'أفضل مندوب تعاملت معه. دقيق جداً.',
        date: '2026-09-11',
        orderNo: '#98690',
        taskType: 'تسليم',
      },
      {
        id: 'DR-103-2',
        clientName: 'لطيفة الدوسري',
        clientInitial: 'ل',
        stars: 5,
        comment: 'ممتاز ومحترم.',
        date: '2026-09-09',
        orderNo: '#98660',
        taskType: 'استلام',
      },
    ],
  },
  {
    driverId: 'DRV-104',
    driverName: 'ماجد القحطاني',
    driverPhoto:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Arab%20man%20wearing%20a%20light%20gray%20uniform%20shirt%2C%20minimal%20plain%20studio%20background%2C%20soft%20diffused%20lighting%2C%20corporate%20identity%20photo%2C%20clear%20and%20sharp&width=200&height=200&seq=driver-photo-104&orientation=squarish',
    averageStars: 4.4,
    totalRatings: 21,
    reviews: [
      {
        id: 'DR-104-1',
        clientName: 'أحمد المطيري',
        clientInitial: 'أ',
        stars: 4,
        comment: 'خدمة جيدة.',
        date: '2026-09-08',
        orderNo: '#98645',
        taskType: 'تسليم',
      },
    ],
  },
  {
    driverId: 'DRV-105',
    driverName: 'بندر الشهري',
    driverPhoto:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20Arab%20man%20with%20a%20clean%20look%20wearing%20a%20blue%20work%20shirt%2C%20simple%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20corporate%20identity%20photo%2C%20high%20clarity&width=200&height=200&seq=driver-photo-105&orientation=squarish',
    averageStars: 4.7,
    totalRatings: 33,
    reviews: [
      {
        id: 'DR-105-1',
        clientName: 'عبدالله الشمري',
        clientInitial: 'ع',
        stars: 5,
        comment: 'سريع ودقيق.',
        date: '2026-09-14',
        orderNo: '#98732',
        taskType: 'استلام',
      },
      {
        id: 'DR-105-2',
        clientName: 'خالد الغامدي',
        clientInitial: 'خ',
        stars: 4,
        comment: 'معاملة حسنة.',
        date: '2026-09-12',
        orderNo: '#98709',
        taskType: 'تسليم',
      },
    ],
  },
];